import { ihm_viewer__dictionary, locale } from 'Application/i18n/i18nViewer';
import { GlassSelect } from '../common/GlassSelect';

export const ComparativeVersionSelector = ({ passive, viewportMode, deniedServices, versions, currentLeftValue, handleComparativeVersionChange }) => {
    const isComparativeMode = viewportMode === 'comparative';
    if (!isComparativeMode) return null;

    const isEditionDenied = deniedServices.includes('showEdition');
    const isNotPassive = !passive;

    const options = versions
        .filter(option => option.value !== -1)
        .flatMap(option => {
            const isEmptyValue = option.value === '';
            return isEmptyValue
                ? [option, { value: -2, disabled: false, label: 'Malocclusion' }]
                : [option];
        });

    return (
        <div id="versionSelectorLeft" className={`vh-select-group versionSelectorLeft ${isEditionDenied ? 'hidden' : ''} comparative`}>
            {isNotPassive && (
                <>
                    <label id='versionSelectorLabelLeft'>{ihm_viewer__dictionary.VERSION_MODE[locale()]}</label>
                    <GlassSelect
                        id="versionSelectorLeft"
                        options={options}
                        value={currentLeftValue}
                        onChange={handleComparativeVersionChange}
                    />
                </>
            )}
        </div>
    );
};
